import {
  Grid,
  ButtonBase,
  Card,
  Box,
  Typography,
  Collapse
} from "@mui/material";
import CardContent from '@mui/material/CardContent';
import React, { useState } from "react";
import { IVehicleTestReport } from "../../../../../../reducers/fleet/types";
import { MotRowDetail } from "./MotRowDetail";
import { DATE_TYPE } from "../../../../../common/utils";
import { getLocalizedDateFormat } from "../../../../../../utils/localized.syntex";
import { useSelector } from "react-redux";
import { IAppState } from "../../../../../../store";

interface IProps {
  row: IVehicleTestReport;
  index: number;
}

export const MobileMotCard = (props: IProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const userState = useSelector((state: IAppState) => state.userReducer);
  const { country } = userState.currentOrganisation.address;

  const borderColour = props.row.testResult === "FAIL" ? "rgba(255, 0, 0, 1)" :
    props.row.testResult === "PASS" ? "rgba(0, 128, 0, 1)" :
      "rgba(0, 0, 0, 1)";

  return (
    <ButtonBase style={{ marginTop: 8, marginBottom: 8 }} onClick={() => {
      if (expanded) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    }} >
      <Card style={{
        width: 'calc(100vw - 120px)',
        border: "2px solid",
        borderColor: `${borderColour}`,
        borderRadius: "3%",
      }}>
        <CardContent>
          <Grid container item xs={12} justifyContent='center'>
            <Grid item xs={6}>
              <Typography>Test Date:</Typography>
              <Typography>{getLocalizedDateFormat(country, props.row.testDate, DATE_TYPE.CONDENSED)}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Expiry Date:</Typography>
              <Typography>{getLocalizedDateFormat(country, props.row.expiryDate, DATE_TYPE.CONDENSED)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Box mt={1} />
            </Grid>
            <Grid item xs={6}>
              <Typography>Odometer Reading:</Typography>
              <Typography>{props.row.odometerReading} {props.row.odometerUnit}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Test Result:</Typography>
              <Typography>{props.row.testResult}</Typography>
            </Grid>
          </Grid>
        </CardContent>
        <Collapse in={expanded} unmountOnExit>
          <MotRowDetail row={props.row} />
        </Collapse>
      </Card>
    </ButtonBase>
  );
};
